import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tag } from 'antd';
import { Enumify } from "enumify-ts";
class UserStatusType extends Enumify() {
    description;
    colour;
    static ENABLED = new UserStatusType("Enabled");
    static BLOCKED = new UserStatusType("Blocked", "red");
    static DISABLED = new UserStatusType("Disabled", "orange");
    static _ = UserStatusType._closeEnum();
    constructor(description, colour) {
        super();
        this.description = description;
        this.colour = colour;
    }
    renderTag() {
        return _jsx(Tag, { color: this.colour, children: this.description });
    }
    static filtersArray() {
        let a = [];
        for (let t of UserStatusType.values) {
            a.push({ text: t.description, value: t.key });
        }
        return a;
    }
    static defaultFilters() {
        return ["ENABLED", "BLOCKED"];
    }
    static selectOptionsArray() {
        return UserStatusType.values.map(it => {
            return {
                label: it.description,
                value: it.key
            };
        });
    }
}
export default UserStatusType;
